import React from 'react';
import PropTypes from 'prop-types';
import style from '../Debug.module.scss';

const AuthClientless = (props = {}) => {
  const {
    clientlessTokenExpireRefresh,
    handleSetClientlessTokenExpireRefresh,
    clientlessRecurringPreAuthZRefresh,
    handleSetClientlessRecurringPreAuthZRefresh,
  } = props;

  return (
    <div className={style.panel}>
      <div className={style.header}>Clientless Auth</div>

      <div className={style.body}>
        <div className={style.formGroup}>
          <div className={style.formLabel}>
            Token Expiration Refresh Duration (milliseconds, 10000 for example)
          </div>
          <div className={style.formInput}>
            <input
              type="text"
              value={clientlessTokenExpireRefresh || ''}
              onChange={handleSetClientlessTokenExpireRefresh}
            />
          </div>
        </div>

        <div className={style.formGroup}>
          <div className={style.formLabel}>
            Recurring Pre AuthZ Refresh (milliseconds, 10000 for example)
          </div>
          <div className={style.formInput}>
            <input
              type="text"
              value={clientlessRecurringPreAuthZRefresh || ''}
              onChange={handleSetClientlessRecurringPreAuthZRefresh}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

AuthClientless.defaultProps = {
  clientlessTokenExpireRefresh: null,
  clientlessRecurringPreAuthZRefresh: null,
};

AuthClientless.propTypes = {
  clientlessTokenExpireRefresh: PropTypes.number,
  clientlessRecurringPreAuthZRefresh: PropTypes.number,
  handleSetClientlessTokenExpireRefresh: PropTypes.func.isRequired,
  handleSetClientlessRecurringPreAuthZRefresh: PropTypes.func.isRequired,
};

export default AuthClientless;
